import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';
import { fetchLoyaltyProgramCMS } from '../api';

export const useCMSLoyaltyProgram = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const { data, isLoading, error } = useSWRImmutable(
    ['loyalty-program', language],
    () => fetchLoyaltyProgramCMS(language)
  );

  return {
    data: data?.data,
    isLoading,
    error,
  };
};
